// Central asset registry for Sri Bhimanakatte Matha
export const ASSETS = {
  logo: "/assets/3wwbyu9b_BheemanaKatte_logo.jpg",
  currentPontiff:
    "/assets/verlre7m_ShriRaghuvarendraTeertharu.jpeg",
  previousPontiff:
    "/assets/SriRaghumanyaTeerthaSwamiji.png",
  madhvacharya:
    "/assets/seur1hf7_Jagadguru_Sri_Madhvacharya.png",
  deity1:
    "/assets/ehmgnazo_diety1.jpg",
  deity3:
    "/assets/n0mtazl3_diety3.jpeg",
  // Client-supplied banner / heritage imagery
  heroBanner:
    "/assets/bw7zfe1a_Picture1bnr.png",
  bannerDeitiesGarlanded:
    "/assets/ev8zy4nx_1.jpeg",
  bannerMathaGate:
    "/assets/About_1.jpeg",
  bannerBronzeIdols:
    "/assets/History.jpeg",
  ourHeritage:
    "/assets/mqhjvo00_OurHeritage.png",
  // Convenience aliases (legacy names kept so existing components don't break)
  heroTemple:
    "/assets/bw7zfe1a_Picture1bnr.png",
  heroRiver:
    "/assets/l5cn0vwe_2.webp",
  aboutMatha:
    "/assets/mqhjvo00_OurHeritage.png",
  quickLinks: {
    purana: "/assets/uqudmj5t_pravachana.png",
    goshala: "/assets/8776e33875668d80d49db23b0f171994981fcc39a06218e78f48fafcf98242c5.png",
    bruhathi: "/assets/9f7934eac581cad4615826cab0589ae6a80a44417400dda1e0587bbdacb919a3.png",
    aradhana: "/assets/pexels-photo-34431714.jpeg",
    dailyEvents: "/assets/photo-1583089892943-e02e5b017b6a",
    bookSeva: "/assets/c1swben0_bookseva.png",
  },
};

export const MATHA = {
  name: "Sri Bhimasethu Munivrunda Mutt",
  aka: "Bhimanakatte Matha",
  fullTitle: "Sri MadAchyuta Prekshacharya Samsthana",
  subTitle: "Jagadguru Sri Madhwacharya Gurumatta",
  address: "Doorvasapuram Post, Bhimanakatte, Thirthahalli, Karnataka 577448",
  phone: "+91 83348 27523",
  email: "info@bheemanakattemutt.com",
  youtube: "https://www.youtube.com/@sribhimanakattematha1339",
  bankDetails: {
    accountName: "Sri Bhimanakatte Matha",
    bank: "Please contact the Matha office for current bank details",
    upi: "sribheemanakatte@upi",
    note: "Kindly note: Online payment gateway will be enabled shortly. For now, devotees may transfer the seva amount via UPI/NEFT and share the reference with the Matha office.",
  },
};
